module.exports = __webpack_public_path__ + "static/btn4-e15bbe0ffed2a248c3cff65d304b968e.png";